<template>
  <div class="stihl-flag" :class="$props.class" v-text="message" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'StihlFlag',
  props: {
    message: { type: String, required: true },
    class: { type: String, default: null },
  },
});
</script>

<style scoped>
.stihl-flag {
  --stihl-flag-width: fit-content;
  --stihl-flag-padding: 0.25rem 0.5rem;
  --stihl-flag-border: 0;
  --stihl-flag-margin: 0;

  color: var(--bs-white);
  background-color: var(--orange-base);

  width: var(--stihl-flag-width);
  padding: var(--stihl-flag-padding);
  border: var(--stihl-flag-border);
  margin: var(--stihl-flag-margin);

  font-family: var(--stihl-font-family-title);
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 900;
  line-height: 0.875rem;
}
</style>
